import { format } from 'date-fns';
import { useEffect, useState } from "react";

export const FormDate = ({
  id,
  name,
  label,
  value,
  disabled,
  onChange,
  onBlur,
  onKeyDown,
  placeholder = null,
  error,
  touched,
  style,
  isLoading,
}) => {
  const classNames = () => {
    let result = "tw-w-auto tw-px-2 tw-py-0 tw-shadow-sm tw-text-indigo-700 sm:tw-text-sm focus:tw-outline-none tw-rounded disabled:tw-opacity-50 disabled:tw-cursor-not-allowed ";
    if (error && touched) {
      result += "tw-placeholder-red-300 focus:tw-ring-red-500 focus:tw-border-red-500 tw-border-red-300 tw-border-2 tw-text-red-900 ";
    } else {
      result += "focus:tw-ring-2 focus:tw-ring-indigo-700 focus:tw-border-indigo-700 tw-border tw-border-gray-500 ";
    }
    if (isLoading) {
      result += " tw-opacity-50 disabled:tw-cursor-not-allowed ";
    }

    return result;
  }


  // const [dateValue, setDateValue] = useState();

  // useEffect(() => {
  //   const dateFormat = "yyyy-MM-dd";
  //   const dateText = format(value, dateFormat);
  //   setDateValue(dateText);
  // }, [value]);

  const handleChange = (e) => {
    //setDateValue(e.target.value);
    onChange(e);
  }

  return (
    <>
      <input
        id={id}
        aria-label={label || 'select date'}
        title={label}
        type="date"
        name={name}
        value={value}
        required={false}
        disabled={disabled}
        placeholder={placeholder}
        onKeyDown={onKeyDown}
        onChange={(e) => handleChange(e)}
        onMouseDown={handleChange}
        onBlur={onBlur}
        className={classNames()}
        style={style}
        max="9999-12-31"
      />
      {
        error && touched &&
        <span className="tw-px-1 tw-text-sm tw-text-red-800 tw-font-bold">
          {error}
        </span>
      }
    </>
  )
}